import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard } from '@guards/auth/auth.guard';
import { RoleGuard } from '@guards/role/role.guard';
import { UsersTableComponent } from '../users/users-table/users-table.component';
import { DeliveryNotesComponent } from '@components/evaluation/delivery-notes/delivery-notes.component';
import { ChargingStationsComponent } from '@components/entities/charging-stations/charging-stations.component';
import { ProfileComponent } from '@components/manage/profile/profile.component';
import { TransactionsComponent } from '@components/evaluation/transactions/transactions.component';
import { DeliveryNoteActionsDialogComponent } from '../../dialog/delivery-note-actions-dialog/delivery-note-actions-dialog.component';
import { ChargingParkSubscriptionDialogComponent } from '@components/dialog/charging-park-subscription-dialog/charging-park-subscription-dialog.component';
import { UsersComponent } from './users.component';
import { UserOverviewComponent } from './user-overview/user-overview.component';
import { EditUserDialogComponent } from '../../dialog/edit-user-dialog/edit-user-dialog.component';
import { CreateUserDialogComponent } from '../../dialog/create-user-dialog/create-user-dialog.component';
import { EditEmailDialogComponent } from '@components/dialog/edit-email-dialog/edit-email-dialog.component';
import { DetailsTransactionDialogComponent } from '../../dialog/details-transaction-dialog/details-transaction-dialog.component';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'users',
          component: UsersComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: { roles: ['Operator'], showAll: true },
          children: [
            {
              path: '',
              component: UsersTableComponent,
              data: { roles: ['Operator'], showAll: true, isOperatorView: true },
            },
            {
              path: 'edit/:key',
              component: EditUserDialogComponent
            },
            {
              path: 'create',
              component: CreateUserDialogComponent
            },
          ],
        },
        {
          path: 'users/:id',
          component: UserOverviewComponent,
          children: [
            {
              path: '',
              redirectTo: 'profile',
              pathMatch: 'full',
            },
            {
              path: 'profile',
              component: ProfileComponent,
              data: { isOperatorView: true, isUserProfile: true },
              children: [
                {
                  path: 'email',
                  component: EditEmailDialogComponent
                }
              ]
            }
          ]
        },
        {
          path: 'chargingstations',
          component: ChargingStationsComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: { roles: ['User'] },
          children: [
            {
              path: '',
              redirectTo: 'summary',
              pathMatch: 'full'
            }
          ]
        },
        {
          path: 'delivery-notes',
          component: DeliveryNotesComponent,
          canActivate: [AuthGuard, RoleGuard], data: { roles: ['User'] },
          children: [
            {
              path: 'edit/:key',
              component: DeliveryNoteActionsDialogComponent,
            }
          ]
        },
        {
          path: 'transactions',
          component: TransactionsComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: { roles: ['User'] },
          children: [
            {
              path: ':key',
              component: DetailsTransactionDialogComponent,
            }
          ]
        },
        {
          path: 'profile',
          component: ProfileComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: { roles: ['Operator', 'User'] },
          children: [
            {
              path: 'charging-park-subscription',
              component: ChargingParkSubscriptionDialogComponent
            },
          ]
        },
      ]
    )
  ],
  providers: [
  ],
})
export class UsersModule { }
